import { createBrowserRouter } from 'react-router'

import { AppShell } from './AppShell'
import { AccountPage } from '../features/account/AccountPage'
import { ApplicationDetailPage } from '../features/applications/ApplicationDetailPage'
import { ConnectionPage } from '../features/connection/ConnectionPage'
import { RechargePage } from '../features/recharge/RechargePage'
import { UsagePage } from '../features/usage/UsagePage'
import { CredentialsPage } from '../features/credentials/CredentialsPage'
import { HomePage } from '../features/dashboard/HomePage'
import { DocsPage } from '../features/docs/DocsPage'
import { RequestsPage } from '../features/requests/RequestsPage'
import { SandboxPage } from '../features/services/SandboxPage'
import { ServiceDetailPage } from '../features/services/ServiceDetailPage'
import { ServicesPage } from '../features/services/ServicesPage'
import { WalletPage } from '../features/wallet/WalletPage'
import { NotFoundPage } from '../routes/NotFoundPage'
import { RouteErrorPage } from '../routes/RouteErrorPage'

export const routes = [
  {
    path: '/',
    element: <AppShell />,
    // Without this react-router renders its own development page — the
    // "Unexpected Application Error" screen with a JavaScript stack trace,
    // on a customer's screen. This replaces it before it can appear, for
    // errors thrown outside a React render where the component boundary
    // cannot reach.
    errorElement: <RouteErrorPage />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'connection', element: <ConnectionPage /> },
      // Service-portal destinations. Both are reachable in either mode: a mode
      // decides what the sidebar offers, never what a URL resolves to.
      { path: 'recharge', element: <RechargePage /> },
      { path: 'usage', element: <UsagePage /> },
      // The old destinations still resolve. A customer who bookmarked
      // /applications, or a support answer that links to it, should land on
      // the page rather than on «صفحه پیدا نشد».
      { path: 'applications', element: <ConnectionPage /> },
      { path: 'applications/:applicationId', element: <ApplicationDetailPage /> },
      { path: 'credentials', element: <CredentialsPage /> },
      { path: 'wallet', element: <WalletPage /> },
      // Members are a fact about the account, so they live on the account
      // page now. The old path still resolves for anything that linked to it.
      { path: 'members', element: <AccountPage /> },
      // Named 'services' rather than anything beginning with "api": both the
      // dev proxy and the container nginx forward /api..., so an /api* SPA
      // route is served by the backend on a hard refresh. routing.test.ts
      // pins that.
      { path: 'services', element: <ServicesPage /> },
      { path: 'services/:code', element: <ServiceDetailPage /> },
      { path: 'services/:code/sandbox', element: <SandboxPage /> },
      { path: 'docs', element: <DocsPage /> },
      { path: 'requests', element: <RequestsPage /> },
      { path: 'account', element: <AccountPage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
]

export const router = createBrowserRouter(routes)
